import { render, staticRenderFns } from "./LegislaDetail.vue?vue&type=template&id=d491f434&scoped=true"
import script from "./LegislaDetail.vue?vue&type=script&lang=js"
export * from "./LegislaDetail.vue?vue&type=script&lang=js"
import style0 from "./LegislaDetail.vue?vue&type=style&index=0&id=d491f434&prod&scoped=true&lang=css"
import style1 from "./LegislaDetail.vue?vue&type=style&index=1&id=d491f434&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d491f434",
  null
  
)

export default component.exports